import React from 'react'
import Button from '../../shared/form/Button'

const ContactUs = props => (
  <div className="island">
    <h2>Contact Us</h2>
    <form encType="multipart/form-data" onSubmit={props.submit}>
      <div className="form-item">
        <label htmlFor="edit-submitted-type-of-inquiry">Type of Inquiry <span className="form-required" title="This field is required.">*</span></label>

        <div className="dropdown">
          <button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style={{ maxWidth: 'none', textAlign: 'left', width: 'auto' }}>
            {props.messageType} <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
            <li><a onClick={props.click('General information')} href="#General">General information</a></li>
            <li><a onClick={props.click('Sponsorship question')} href="#Sponsorship">Sponsorship question</a></li>
            <li><a onClick={props.click('Technical question')} href="#Technical">Technical question</a></li>
          </ul>
        </div>
      </div>

      <div className="form-item">
        <label htmlFor="edit-submitted-message">Message <span>*</span></label>
        <div className="form-textarea-wrapper">
          <textarea id="edit-submitted-message" cols="60" rows="5" className="form-textarea required form-control" name="message" onChange={props.change}></textarea>
        </div>
      </div>

      <div className="form-actions">
        <Button loading={props.loading}>Submit</Button>
      </div>
    </form>
  </div>
)

ContactUs.defaultProps = {
  messageType: 'Select Inquiry'
}

export default ContactUs
